import session from "../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../services/api";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()


export default {
    data() {
        return {
            locale: LocService,
            title : '',
            model: {
                name: '',
                enName: '',
                shortDescription: '',
                enShortDescription: '',
                longDescription: '',
                enLongDescription: '',
            },
            free: false,
            isTemplate: false,
            selectedImage: null,
            selectedHeaderImagePreview: null,
            imageHeaderUrl: null,
            partnerCompanies: [],
            idToEdit: null,
            fromDate : null,
            toDate: null,
            chooseUser: false,
            selectedPartnerCompany: null,
            selectedUsers: [],
            isVisibleAddUserToTerm: false,
            showAddTrainerToSlot: false,
        }
    },
    methods: {
        addPersonalProgram: addPersonalProgram,
        editPersonalProgram: editPersonalProgram,
        showChoseUser: showChoseUser,
        deletePhoto: deletePhoto,
        uploadPhoto: uploadPhoto,
        loadTextFromFile: loadTextFromFile,
        getPersonalProgramById: getPersonalProgramById,
        loadCompanyPartner: loadCompanyPartner,
        removeSelectedUser: removeSelectedUser,
        onTemplateChanged: onTemplateChanged,
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.idToEdit = this.$route.query.id;
        this.title = this.idToEdit != null ? LocService.t('label_edit_personal_program') :  LocService.t('label_add_new_personal_program')
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.showAddTrainerToSlot = CONFIG_COMPANY.SHOW_ADD_TRAINER_ON_SLOT;
        this.isVisibleAddUserToTerm = session.getConfig().canAddUserWithTerm;
        if(this.idToEdit != null){
            this.getPersonalProgramById();
        }
        this.loadCompanyPartner();
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeChooseUser', () => {
            _self.chooseUser = false;
        });

        this.$topnavbar.$on('onUserSelected', (data) => {
            if(_self.isTemplate === true){
                return;
            }
            // _self.chooseUser = false;
            if(!_self.selectedUsers.map(u => u.id).includes(data.id)){
                _self.selectedUsers.push(data)
            }
        });
    }
}

function loadCompanyPartner() {
    let _self = this;

    AdminApiService.getCompanyPartners()
        .then((response) => {
            _self.partnerCompanies = response.data
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function getPersonalProgramById(){
    let _self = this;
    AdminApiService.getPersonalProgramById(this.idToEdit, false)
        .then((response) => {
            let data = response.data.details;
            _self.model.name = data.name
            _self.model.enName = data.enName
            _self.model.shortDescription = data.shortDescription
            _self.model.enShortDescription = data.enShortDescription
            _self.model.longDescription = data.longDescription
            _self.model.enLongDescription = data.enLongDescription
            _self.fromDate = _self.$moment(data.startTime * 1000).format('YYYY-MM-DD');
            _self.toDate = _self.$moment(data.endTime * 1000).format('YYYY-MM-DD');
            _self.imageHeaderUrl = data.imageUrl;
            _self.free = data.free != null ? data.free : false;
            _self.isTemplate = data.isTemplate === true;
            if(data.publicProgram !== true){
                _self.selectedUsers = []
                _self.selectedUsers.push({
                    name: data.firstName,
                    suername: data.lastName,
                    username: data.username,
                    id: data.userId,
                })
            }
            _self.selectedPartnerCompany = data.partnerCompanyName
            if(_self.isTemplate === true){
                _self.selectedUsers = [];
                _self.selectedPartnerCompany = null;
                _self.free = false;
            }

        })
        .catch(error => {
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function deletePhoto(){
    let _self = this;
    if(_self.imageHeaderUrl == null){
        _self.selectedImage = null;
        _self.selectedHeaderImagePreview = null;
        this.$refs.fileInput1.value = null;
        return;
    }

    _self.selectedImage = null;
    _self.selectedHeaderImagePreview = null;
    _self.imageHeaderUrl = null;
    _self.$refs.fileInput1.value = null;
}

function loadTextFromFile(ev) {
    var i = 0;
    for (i = 0; i < ev.target.files.length; i++) {
        const file = ev.target.files[i];
        if (file.size > 5000000) {
            alert(this.locale.t('label_max_size_picture'))
            return
        }
        const reader = new FileReader();
        this.selectedImage = file;
        this.selectedHeaderImagePreview = URL.createObjectURL(file);
        reader.onload = e => {
            // console.log(e.target.result);
            // _self.files.push(e.target.result);
        }

        reader.readAsDataURL(file);

    }
}

function removeSelectedUser(sUser){
    this.selectedUsers = this.selectedUsers.filter(u => sUser.id !== u.id)
    // this.selectedUsers = [];
    // this.selectedUsers = null;
}
function showChoseUser(){
    if(this.isTemplate === true) return;
    this.chooseUser = true;
}

function onTemplateChanged(){
    if(this.isTemplate !== true) return;
    this.chooseUser = false;
    this.selectedUsers = [];
    this.selectedPartnerCompany = null;
    this.free = false;
}

function uploadPhoto() {
    let _self = this;
    if(this.selectedImage == null) {
        this.addPersonalProgram();
        return;
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});

    AdminApiService.uploadProgramImage(this.selectedImage, CONFIG_COMPANY.NAME)
        .then((response) => {
            _self.imageHeaderUrl = response.data.url
            _self.addPersonalProgram();
            // swal(LocService.t('label_success'), LocService.t('label_ci_header_image_uploaded_success'), 'success')
        })
        .catch((error) => {
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}


function addPersonalProgram() {
    let _self = this;
    // if(this.selectedUsers.length === 0){
    //     swal( LocService.t('label_error'), LocService.t('label_pp_choose_user'), 'error')
    //     return;
    // }
    if(_self.model.name.length === 0){
        swal( LocService.t('label_error'), LocService.t('label_td_name_required'), 'error')
        return;
    }
    if(this.idToEdit != null){
        this.editPersonalProgram();
        return;
    }
    var model = {
        type: "PERSONAL",
        fromDate: _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate: _self.$moment(_self.toDate).format('DD-MM-YYYY'),
        toUser: this.selectedUsers.map(e => e.id)[0],
        name: _self.model.name,
        enName: _self.model.enName,
        toPartnerCompany: _self.selectedPartnerCompany,
        imageUrl: _self.imageHeaderUrl,
        free: _self.free,
        template: _self.isTemplate,
        shortDescription: _self.model.shortDescription,
        enShortDescription: _self.model.enShortDescription,
        longDescription: _self.model.longDescription,
        enLongDescription: _self.model.enLongDescription,
        data: []
    }

    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte...</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});


    AdminApiService.addPersonalProgram(model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t("label_pp_success_saved"), 'success')
            this.$router.back()
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function editPersonalProgram(){
    let _self = this;
    var model = {
        id: this.idToEdit,
        type: "PERSONAL",
        fromDate: _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate: _self.$moment(_self.toDate).format('DD-MM-YYYY'),
        toUser: this.selectedUsers.map(e => e.id)[0],
        name: _self.model.name,
        enName: _self.model.enName,
        toPartnerCompany: _self.selectedPartnerCompany,
        imageUrl: _self.imageHeaderUrl,
        free: _self.free,
        isTemplate: _self.isTemplate,
        shortDescription: _self.model.shortDescription,
        enShortDescription: _self.model.enShortDescription,
        longDescription: _self.model.longDescription,
        enLongDescription: _self.model.enLongDescription,
        data: []
    }

    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte...</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});


    AdminApiService.editPersonalProgram(model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t("label_pp_success_saved"), 'success')
            this.$router.back()
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}



// WEBPACK FOOTER //
// ./src/components/Personal/AddPersonalProgram.js